import type { ReactElement } from 'react';

import type { LazyStyles } from './hooks';
import { useStylesWithoutDuplicates } from './hooks';

interface CssComponent {
  children: ReactElement<any>;
  identifier: string;
  styles: LazyStyles;
}

export const LazyStylesComponent = ({ children, styles, identifier }: CssComponent) => {
  useStylesWithoutDuplicates(identifier, styles);

  return children;
};
